import { Modal, Button } from 'react-bootstrap';
import ElysiaLogo from '@/assets/icon-elysia-brain.svg?react';
import { useNavigate } from 'react-router-dom';
import useElysiaStore from '@/app/elysia-store';

interface BlockModalProps {
  show: boolean;
  hide: () => void;
  type: string;
}

const BlockModal = ({ show, hide, type }: BlockModalProps) => {
  const navigate = useNavigate();
  const setChatAgent = useElysiaStore((state) => state.setChatAgent);

  const onHide = () => {
    if (type === 'soft') {
      hide();
    } else {
      hide();
      navigate('/');
      setChatAgent?.('Generic');
    }
  };

  return (
    <Modal
      show={show}
      keyboard={false}
      dialogClassName="elysia-modal"
      data-testid="update-profile-modal"
      className="block-modal"
      centered
    >
      <Modal.Header>
        <Modal.Title data-testid="update-profile-heading">Update Your Profile</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="d-flex gap-2 mb-3" data-testid="update-profile-modal-sub-heading">
          <ElysiaLogo />
          Without an updated profile, you're not getting the best out of Career Coach. Update it now
          then start exploring.
        </p>
      </Modal.Body>

      <Modal.Footer className="justify-content-between">
        <Button
          variant="secondary"
          data-testid="update-profile-modal-cancel-button"
          onClick={onHide}
        >
          {type === 'soft' ? 'Dismiss' : 'Exit'}
        </Button>
        <div>
          <Button
            variant="secondary"
            data-testid="update-profile-modal-proceed-button"
            className="me-2"
            onClick={() => navigate('/app-store')}
          >
            Explore AI Apps
          </Button>
          <Button
            variant="primary"
            data-testid="update-profile-modal-proceed-button"
            onClick={() => navigate('/myprofile')}
          >
            Update Profile
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default BlockModal;
